import * as React from 'react';

import Email16 from './Email16';

export const email16 = () => <Email16 />;

export default {
    title: 'Icon/Line/Email16',
    component: Email16,
    parameters: {
        notes: "`import Email16 from 'box-ui-elements/es/icon/line/Email16';`",
    },
};
